import { useContext, useEffect } from "react";
import { Socket } from "socket.io-client";
import { ApplicationState } from "../../../context/ApplicationStateContext";
import { useQueryClient } from "@tanstack/react-query";

function useSocketSubscribe(socket: Socket) {
  const queryClient = useQueryClient();
  const {
    state: { notificationCount },
    dispatch,
  } = useContext(ApplicationState);
  useEffect(() => {
    if (socket === null) return;

    socket?.on("disconnect", (reason: any) => {
      console.log(`disconnected because of ${reason}`);
    });

    socket?.on("notification", (data) => {
    //   queryClient.invalidateQueries({ queryKey: ["notifications"] });
      dispatch({
        type: "SET_NOTIFICATION_COUNT",
        payload: notificationCount + 1,
      });
    });
  }, [socket?.connected, notificationCount]);
}

export default useSocketSubscribe;
